import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '=',
        surveyGroup: '=',
        company: '='
    },
    template: `
        <div class="heading01" ng-if="vm.formSubmission.isTrial">
            <h2></h2>
            <forms-language-switcher form-submission="vm.formSubmission" selected-language="vm.selectedLanguage" />
        </div>
        <div class="items" ng-if="vm.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY === vm.surveyGroup.type">
            </br>
            <a class="btn discrete small" ng-click="vm.redirectToPortal()">
                {{ 'survey.Back to course' | translate }}
            </a>
        </div>

        <div class="loader02" ng-if="!vm.form && vm.isLoading && vm.error===false">{{ 'question.Please wait' | translate }}</div>
        <p ng-if="vm.error !== false " class="alert alert-danger"><span ng-bind-html="vm.error"></span></p>
        <p ng-if="vm.notification !== false" class="alert alert-notify"><span ng-bind-html="vm.notification"></span></p>
        <div ng-if="vm.form && vm.error===false">
            <div class="quiz">
                <p ng-bind-html="vm.introduction"></p>
                <p class="desc"><span class="red">*</span> - {{ 'forms.This question is mandatory' | translate }}</p>
                <div ng-repeat="category in vm.categories">
                   <survey-public-survey-category ng-if="category.id"
                       form="vm.form"
                       form-submission="vm.formSubmission"
                       category="category"
                       opened-tab="vm.openedTab"
                       index="$index"
                       counter="vm.counter"
                       categories-count="vm.categoriesCount"
                       submit="vm.submit(isDraft)"
                       disabled="vm.disabled"
                   />
                   <div class="question theme02" ng-if="!category.id" ng-repeat="question in category.questions">
                       <survey-public-survey-question-checkbox
                            form="vm.form"
                            answered-questions="vm.answeredQuestionsCount.checkbox"
                            question="question"
                            counter="vm.counter[question.id]"
                            disabled="vm.disabled"
                            ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX"
                       />
                       <survey-public-survey-question-radio
                            form="vm.form"
                            answered-questions="vm.answeredQuestionsCount.radio"
                            question="question"
                            counter="vm.counter[question.id]"
                            disabled="vm.disabled"
                            ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.RADIO"
                       />
                       <survey-public-survey-question-free-text
                            form="vm.form"
                            counter="vm.counter[question.id]"
                            answered-questions="vm.answeredQuestionsCount.freeText"
                            question="question"
                            disabled="vm.disabled"
                            ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                       />
                       <survey-public-survey-question-scale
                            form="vm.form"
                            counter="vm.counter[question.id]"
                            answered-questions="vm.answeredQuestionsCount.scale"
                            question="question"
                            disabled="vm.disabled"
                            ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
                       />
                       <survey-public-survey-question-matrix
                            form="vm.form"
                            counter="vm.counter[question.id]"
                            answered-questions="vm.answeredQuestionsCount.matrix"
                            question="question"
                            disabled="vm.disabled"
                            ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.MATRIX"
                       />
                    </div>
                </div>
            </div>
            <ul ng-if="!vm.disabled" class="actions01">
                <li class="primary"><button class="btn main" ng-click="vm.submit(false)">{{ vm.getSubmitButtonText() }}</button></li>
                <li class="primary"><a class="btn bordered02" ng-if="!vm.formSubmission.isTrial" ng-click="vm.submit(true)">{{ 'general.Save as draft' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($window, $translate, $rootScope, $state, $stateParams, $scope, toastr, lodash, ModalService, ResponseService, CommonService,
                 MomentService, TokenService, FormSubmissionService, SurveyGroupService, FormSubmissionAnswerResource,
                 FormSubmissionResource, ErrorHandlerFactory, SurveyGroupResource,
                 QUESTIONS_TYPE_ENUM, FORMS_SUBMISSION_STATUS_ENUM, SURVEY_PARTICIPANT_STATUS_ENUM,
                 SURVEY_INTRODUCTION_PLACEHOLDER_ENUM, SURVEY_GROUP_TYPE_ENUM) {
        this.$window = $window;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.ResponseService = ResponseService;
        this.CommonService = CommonService;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.FormSubmissionService = FormSubmissionService;
        this.SurveyGroupService = SurveyGroupService;
        this.FormSubmissionAnswerResource = FormSubmissionAnswerResource;
        this.FormSubmissionResource = FormSubmissionResource;
        this.SurveyGroupResource = SurveyGroupResource;
        this.ErrorHandlerFactory = ErrorHandlerFactory;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.SURVEY_PARTICIPANT_STATUS_ENUM = SURVEY_PARTICIPANT_STATUS_ENUM;
        this.SURVEY_INTRODUCTION_PLACEHOLDER_ENUM = SURVEY_INTRODUCTION_PLACEHOLDER_ENUM;
        this.SURVEY_GROUP_TYPE_ENUM = SURVEY_GROUP_TYPE_ENUM;
        this.openedTab = 0;
        this.language = this.formSubmission.user ? this.formSubmission.user.coursyLanguage.toLowerCase() : TokenService.getActiveLanguage(true);
        this.selectedLanguage = this.formSubmission.user ? this.formSubmission.user.coursyLanguage : TokenService.getActiveLanguage();
        this.defaultLanguage = TokenService.getCompanyLanguage();
        // force to use user preferred language
        $translate.use(this.language);
        const listener = $rootScope.$on('survey:language', (event, data) => {
            this.language = data;
            this.introduction = this.formSubmission.isTrial ? null : this.getIntroduction();
            this.form = false;
            FormSubmissionResource.get({
                guid: $state.params.guid,
                expand: 'form,anySurveyGroupParticipant'
            }).$promise.then((updatedFormSubmission) => {
                this.formSubmission = updatedFormSubmission;
                this.$onInit();
            });
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        this.isLoading = false;
        this.counter = {};
        this.error = false;
        this.notification = false;
        this.participant = this.formSubmission.anySurveyGroupParticipant;
        this.introduction = this.formSubmission.isTrial ? null : this.getIntroduction();
        if (this.formSubmission.isTrial) {
            this.loadTest();
            return;
        }
        if (this.surveyGroup.deadline && this.MomentService.isPassedTimeStamp(this.surveyGroup.deadline) && this.participant.status !== this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.COMPLETED) {
            this.error = this.$translate.instant('survey.Deadline for answering this survey has passed');
        }
        else if (this.participant.status === this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.DELETED) {
            this.error = this.$translate.instant('survey.You can no longer submit answers to this survey');
        }
        else if (this.participant.status === this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.COMPLETED) {
            this.notification = this.$translate.instant('survey.You have already submitted your answers');
            if (this.surveyGroup.type === this.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY) {
                // disable confirm dialog form browser
                this.$window.onbeforeunload = null;
                this.loadTest();
                this.disabled = true;
            }
        }
        else if (this.surveyGroup.isFixedOrderType) {
            this.SurveyGroupResource.occurrenceTrainings({ guid: this.$stateParams.guid })
                .$promise
                .then((response) => {
                    if (this.SurveyGroupService.isFixedTypePreviousTrainingPassed(this.surveyGroup.trainingId, response)) {
                        this.loadTest();
                    }
                    else {
                        this.error = this.$translate.instant('survey.order_fixed_message', {
                            portalUrl: this.surveyGroup.portalCourseUrl
                        });
                    }
                });
        }
        else {
            this.loadTest();
        }

        this.answeredQuestionsCount = {
            checkbox: 0,
            radio: 0,
            freeText: 0,
            scale: 0,
            matrix: 0
        };
    }

    redirectToPortal () {
        this.$window.onbeforeunload = null;
        this.$window.location.href = this.surveyGroup.portalCourseUrl;
    }

    getIntroduction () {
        const deadlinePlaceholder = this.SURVEY_INTRODUCTION_PLACEHOLDER_ENUM.GROUP_DEADLINE;
        const deadline = this.MomentService.formatTimeStamp(this.surveyGroup.deadline);
        let surveyGroupI18n = this.lodash.find(this.surveyGroup.surveyGroupI18ns, (i18n) => {
            return this.language.toUpperCase() === i18n.language;
        });

        if (!surveyGroupI18n) {
            surveyGroupI18n = this.lodash.find(this.surveyGroup.surveyGroupI18ns, (i18n) => {
                return this.company.defaultLanguage === i18n.language;
            });
        }

        if (!surveyGroupI18n) {
            return '';
        }

        return this.lodash.replace(surveyGroupI18n.introduction, new RegExp(deadlinePlaceholder, 'g'), deadline);
    }

    loadTest () {
        this.isLoading = true;
        if (this.formSubmission.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.NOT_STARTED) {
            // call start to set correct submission start time and status
            this.FormSubmissionResource.start({ guid: this.formSubmission.guid }).$promise.then(() => {});
        }
        this.getQuestions().then(() => {
            this.isLoading = false;
            this.form = {
                language: this.language,
                guid: this.formSubmission.guid,
                formId: this.formSubmission.formId,
                answers: {}
            };
        });
    }

    submit (isDraft) {
        if (this.formSubmission.isTrial) {
            this.$state.go('authorized.forms.forms.form.general', { id: this.formSubmission.formId });
            return;
        }
        this.form.isDraft = isDraft;
        if (isDraft) {
            this.FormSubmissionAnswerResource.batchCreate({ expand: 'form', _lang: this.language }, this.form).$promise
                .then(data => this.handleSuccess(data, isDraft))
                .catch(response => this.handleErrors(response));
        }
        else {
            this.FormSubmissionAnswerResource.batchCreate({ expand: 'form', _lang: this.language, validateOnly: true }, this.form).$promise.then(() => {
                const confirmMessage = this.$translate.instant('survey.After submitting the answers you cannot change them. Are you sure you wish to submit the survey?');
                this.ModalService.confirm(confirmMessage, 'medium').then(() => {
                    this.FormSubmissionAnswerResource.batchCreate({ expand: 'form', _lang: this.language }, this.form).$promise
                        .then(data => this.handleSuccess(data, isDraft))
                        .catch(response => this.handleErrors(response));
                });
            }).catch(response => this.handleErrors(response));
        }
    }

    handleSuccess (data, isDraft) {
        if (isDraft) {
            this.toastr.success(this.$translate.instant('general.Draft saved'));
        }
        this.formSubmission = data;
        if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
            this.$state.go('survey.survey.finished', { guid: this.formSubmission.guid });
        }
        else if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.IN_PROGRESS) {
            this.loadTest();
        }
    }

    handleErrors (response) {
        // just in case try to reload survey if response is empty
        if (!response.data) {
            this.loadTest();
            return;
        }
        const errors = this.ErrorHandlerFactory.parseFormErrors(response);
        // check if there is a generic error, if so, only show that error
        if (errors['*']) {
            this.error = errors['*'];
            return;
        }
        const uniqueErrors = [];
        this.lodash.forEach(errors, (error) => {
            if (uniqueErrors.indexOf(error) === -1) {
                this.toastr.error(error);
                uniqueErrors.push(error); // filter out duplicate errors
            }
        });

        const parsedErrors = this.ResponseService.parseErrors(response);
        this.lodash.forEach(this.form.answers, (answer, key) => {
            if (this.lodash.has(parsedErrors, `answers.${key}`)) {
                this.lodash.assign(answer, { errors: parsedErrors.answers[key] });
            }
        });
    }

    getQuestions () {
        const params = {
            guid: this.formSubmission.guid,
            pageSize: 0,
            _lang: this.language,
            fallbackLanguage: this.defaultLanguage
        };
        return this.FormSubmissionResource.surveyQuestions(params).$promise.then((categories) => {
            // create overall question counter and load answers
            let counter = 1;
            this.FormSubmissionService.getAnswers(this.formSubmission)
                .then((answers) => {
                    this.lodash.forEach(categories, (category) => {
                        this.lodash.forEach(category.questions, (question) => {
                            this.counter[question.id] = counter++;
                            const questionTypes = [
                                this.QUESTIONS_TYPE_ENUM.KEYS.RADIO,
                                this.QUESTIONS_TYPE_ENUM.KEYS.SCALE,
                                this.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT
                            ];
                            if (this.lodash.includes(questionTypes, question.type)) {
                                question.submittedAnswer = this.lodash.find(answers, answer => answer.questionId === question.id);
                            }
                            else if (question.type === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX) {
                                question.submittedAnswers = this.lodash.filter(answers, answer => answer.questionId === question.id);
                            }
                            else if (question.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
                                this.lodash.forEach(question.childQuestions, (childQuestion) => {
                                    childQuestion.submittedAnswer = this.lodash.find(answers, answer => answer.questionId === childQuestion.id);
                                });
                            }
                            this.categories = categories;
                            this.categoriesCount = this.categories.length;
                        });
                    });
                });
        }).catch(response => {
            this.error = response.data.message;
        });
    }

    getSubmitButtonText () {
        return this.formSubmission.isTrial ? this.$translate.instant('forms.Back to form') : this.$translate.instant('general.Save and submit');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/survey/index.js